import React, { Component } from 'react'
import PopupLayout from './layoutModal'
import '../../assets/css/app.css'

class ConsentModal extends Component {
  constructor(props) {
    super(props)
    this.state = { selected: 1 }
  }

  render() {
    return (
      <PopupLayout display={this.props.display}>
        <div className="detail-1" style={{ display: this.state.selected == 1 ? 'initial' : 'none' }}>
          <div className="modal-header">
            <h5 className="modal-title">
                ข้อกำหนดและเงื่อนไขการใช้บริการสิทธิพิเศษ
            </h5>
          </div>

          <div className="modal-body">
          
            <ol>
              <li>ข้าพเจ้าตกลงและยินยอมใช้บริการสิทธิพิเศษที่ได้รับจากบริษัท บัตรกรุงศรีอยุธยา จำกัด (“บริษัทฯ”) ตามเงื่อนไขที่บริษัทฯ กำหนด ทั้งนี้ ข้าพเจ้ารับทราบว่าบริษัท เวิลด์ รีวอร์ด โซลูชั่น จำกัด (“ผู้ให้บริการ”) เป็นผู้ให้บริการสิทธิพิเศษนี้แก่ข้าพเจ้าโดยตรง การให้บริการดังกล่าวรวมถึง การรับจองสิทธิพิเศษ ติดต่อประสานงานเพื่ออำนวยความสะดวกในการให้บริการสิทธิพิเศษ และบริษัทฯ เป็นเพียงผู้จัดหาสิทธิพิเศษให้แก่ข้าพเจ้าเท่านั้น ไม่ได้มีส่วนเกี่ยวข้องกับการให้บริการสิทธิพิเศษของผู้ให้บริการแต่อย่างใด</li>
              <br />
              <li>ข้าพเจ้ารับทราบว่าสิทธิพิเศษที่ข้าพเจ้าได้รับจากบริษัทฯ ไม่สามารถแลก คืน หรือเปลี่ยนเป็นเงินสด หรือของอื่นใดได้ รวมตลอดทั้งไม่สามารถโอนให้แก่บุคคลอื่นได้ เว้นแต่ได้รับความยินยอมจากบริษัทฯ</li>
              <br />
              <li>ข้าพเจ้าตกลงและยินยอมให้บริษัทฯ เก็บ รวบรวม ใช้ เปิดเผย และ/หรือ โอนข้อมูลของข้าพเจ้าที่ให้ไว้ในขณะนี้ หรือที่มีอยู่หรือจะมีกับบริษัทฯ หรือข้อมูลของข้าพเจ้าที่บริษัทฯ ได้รับหรือเข้าถึงได้จากแหล่งข้อมูลอื่น (“ข้อมูลส่วนบุคคล”) ให้แก่ผู้ให้บริการ บุคคลที่เกี่ยวข้องกับการให้บริการสิทธิพิเศษแก่ข้าพเจ้า พันธมิตรทางธุรกิจ (รวมถึงแต่ไม่จำกัดเพียงโรงแรมและห้องอาหาร)      ผู้ประมวลผลข้อมูล ทั้งในประเทศและต่างประเทศ (“ผู้ที่ได้รับข้อมูล”) โดยมีวัตถุประสงค์เพื่อเป็นการส่งเสริมการขายของบริษัทฯ และเพื่ออำนวยความสะดวกให้แก่ข้าพเจ้าในการใช้บริการสิทธิพิเศษข้างต้น และข้าพเจ้ายินยอมให้ผู้ที่ได้รับข้อมูลจากบริษัทฯ เก็บรวบรวม ใช้ เปิดเผยและ/หรือโอนข้อมูลส่วนบุคคลของข้าพเจ้าเพื่อวัตถุประสงค์ภายใต้ข้อสัญญาที่ตกลงกันระหว่างผู้ได้รับข้อมูลและบริษัทฯ ทั้งนี้ การดำเนินการดังกล่าวต้องไม่เป็นการกระทบต่อสิทธิความเป็นเจ้าของข้อมูลส่วนบุคคลของข้าพเจ้าเกินสมควร</li>
              <br />
              <li>ข้าพเจ้าตกลงให้ข้อมูลส่วนบุคคลเพิ่มเติมแก่บริษัทฯ ตามที่ร้องขอ และการให้ข้อมูลที่เพิ่มเติมภายหลังนี้อยู่ภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการฉบับนี้ด้วย</li>
              <br />
              
            </ol>
          </div>
          <div className="modal-footer text-center d-block ">
            <button
              type="button"
              className="btn btn-primary btn-md button_agree_term"
              onClick={() => {
                this.props.closePopup()
              }}
            >
              ยอมรับข้อกำหนดและเงื่อนไข
            </button>
          </div>
          <div className="modal-footer text-center d-block pt-0">
            <button
              type="button"
              className="btn btn-primary btn-md"
              onClick={() => {
                this.setState({ selected: 2 })
              }}
            >
              ยกเลิก
            </button>
          </div>
        </div>
        <div className="detail-2" style={{ display: this.state.selected == 2 ? 'initial' : 'none' }}>
          <div className="modal-header">
            <h5 className="modal-title" id="consent_form_title">
              ติดต่อสอบถาม
            </h5>
          </div>
          <div className="modal-body text-center">
            <p>
              <span>
                <i className="icon-envelope"></i> whiteglove@worldrewardsolutions.com
              </span>
              <br />
              <i className="icon-phone"></i> โทรศัพท์ :  02-1141946
              <br />
              <i className="icon-clock"></i> สำรองสิทธิ์ทางโทรศัพท์ระหว่าง 09:00-21:00 น. ทุกวันไม่เว้นวันหยุด
              กรณีฉุกเฉินหรือต้องการความช่วยเหลือเร่งด่วนสามารถติดต่อได้ตลอด 24 ชั่วโมง
            </p>
          </div>
          <div className="modal-footer text-center d-block pt-0">
            <button
              type="button"
              className="btn btn-primary btn-md"
              onClick={() => {
                this.setState({ selected: 1 })
              }}
            >
              กลับสู่หน้าข้อกำหนดและเงื่อนไข
            </button>
          </div>
        </div>
      </PopupLayout>
    )
  }
}

export default ConsentModal
